import { offsetFromPageNumberAndLimit } from './functions';

export const pageNumberToOffetLimitEffect = (options = {}) => {
  const { limit, onClickPageNumber } = options;
  return (e, { pageNumber }) => {
    const offset = offsetFromPageNumberAndLimit(pageNumber, limit);
    onClickPageNumber(e, { pageNumber, offset, limit });
  };
};
